module.exports = __webpack_public_path__ + "img/ic_baby_breathe.b757698a.png";